export default __webpack_public_path__ + "static/media/factor_item_4.164898d7.png";